import { Card,Table } from "react-bootstrap"
import { useLocation, useParams } from "react-router-dom";
import PageTitle from "../layouts/PageTitle";
import { useEffect,useMemo, useState } from "react";
import { getUser_Guests, getUserGuests, updateGuestStatus } from "../../services/UserServices/UserService";
import { TableLoaderRow, TableEmptyRow } from "../components/TableLoader";
import Pagination from "../components/Pagination";
import debounce from "lodash/debounce";

import { Modal, Button, Badge } from "react-bootstrap";
import { Eye } from "react-feather"; // or use font-awesome
import toast from "react-hot-toast";
const USER_GUESTS = () => {

 const [guests, setGuests] = useState([]);
const {id}=useParams();
const [debouncedSearch, setDebouncedSearch] = useState("");
const [search,setSearch]=useState("")
 const [currentPage, setCurrentPage] = useState(0);
 const [itemsPerPage, setItemsPerPage] = useState(10)
   const [totalItems, setTotalItems] = useState(0);
    const [loading,setLoading ]= useState(false)
      const [sortBy, setSortBy] = useState("");
      const [showModal, setShowModal] = useState(false);
const [selectedGuest, setSelectedGuest] = useState(null);
  const getGuests= async () => {
       
       try {
         setLoading(true); 
         const res = await getUser_Guests(id,currentPage,10,debouncedSearch,statusFromQuery);
         
         setGuests(res?.data?.data?.guests);
         setTotalItems(res?.data?.data.count);
       } catch (error) {
         console.error(error?.response?.data?.message);
       }
       finally{
         setLoading(false);
       }
     };
  useEffect(() => {
   
     if (id) {
       getGuests();
     }
    }, [debouncedSearch ,currentPage,sortBy]);

 const debouncedHandler = useMemo(
  () =>
    debounce((value) => {
      // 🔥 hit API only if 3+ chars OR empty (for reset)
      if (value.length >= 1 || value.length === 0) {
        setDebouncedSearch(value);
        setCurrentPage(0); // reset pagination
      }
    }, 800),
  []
);

useEffect(() => {
  return () => {
    debouncedHandler.cancel();
  };
}, []);
const handleOpenModal = (guest) => {
  setSelectedGuest(guest);
  setShowModal(true);
};

const handleCloseModal = () => {
  setShowModal(false);
  setSelectedGuest(null);
};


useEffect(() => {
  setCurrentPage(0)
}, [search,sortBy]);

 const updateStatus = async (data,invite_id,status) => {
   try {
      console.log("data",data)
 const payload={
   hostId:id,
   guestIds:[data],
   status:status,
   inviteId:invite_id
  
 }
 
     await updateGuestStatus(payload); // 👈 your API endpoint
     toast.success(`Status updated `);
     setSelectedGuest((prev) => ({
  ...prev,
  invites: prev.invites.map((invite) =>
    invite._id === invite_id
      ? { ...invite, status: status }
      : invite
  ),
}));

   getGuests()
   } catch (err) {
     toast.error("Something went wrong");
   }  
 };


   const location = useLocation();
    const historyData = location.state?.history;
   const totalPages = Math.ceil(totalItems / itemsPerPage);
 const statusFromQuery = useMemo(() => {
  const params = new URLSearchParams(location.search);
  return params.get("status"); // "declined" | "accepted" | null
}, [location.search]);


  return (
    <div className="qx-page">
  
<PageTitle
  breadcrumbs={[
    {
      label: "User List",
      path: "/user-management",
    },
    {
      label: historyData?.user?.hostName || "User",
      path: `/user-details/${id}`,
      state: {
        history: {
          user: historyData?.user,
        },
      },
    },
    {
      label: "Guests",
    },
  ]} />
  <h2 className=" mb-4 user-detail-title font-fm" style={{ fontSize: "20px" }}>
       </h2>
  <div className="pb-2 d-flex gap-2 justify-content-between">
   {/* <input
  type="text"
  style={{ borderRadius: "0.5rem", width: "100%" }}
  className="form-control inpp"
  placeholder="Search name, phone-number"
  value={search}
  onChange={(e) => {
    setSearch(e.target.value);
    debouncedHandler(e.target.value);
  }}
/> */}
  {/* <select
          className="form-control"
          style={{ borderRadius: "0.5rem", width: "200px" }}
          value={sortBy}
          onChange={(e) => setSortBy(e.target.value)}
        >
    <option value="">Event Types</option>
              <option value="custom">Custom</option>
              <option value="0">Roka</option>
                  <option value="1">Engagement</option>
              <option value="2">Haldi</option>
              <option value="4">Sangeet</option>
              <option value="5">Cocktail</option>
              <option value="6">Wedding</option>
              <option value="7">Music Bash</option>
              <option value="3">Mehndi</option>
              <option value="8">Reception</option>
        </select> */} 
      </div>
      
   <div className="qx-toolbar mb-3">
    <div className="qx-search-wrap qx-search-wrap--icon">
      <input
        type="text"
        className="form-control"
        placeholder="Search by name or phone number"
        value={search}
        onChange={(e) => {
          setSearch(e.target.value);
          debouncedHandler(e.target.value);
        }}
      />
      {search ? (
        <button
          type="button"
          className="qx-search-clear"
          aria-label="Clear search"
          onClick={() => {
            setSearch("");
            setDebouncedSearch("");
          }}
        >
          ×
        </button>
      ) : null}
    </div>
  </div>
      <Card className="qx-table-card">
      <Card.Body>
        <Table responsive className="mb-0">
          <thead>
            <tr>
              <th><strong>S.NO</strong></th>
              <th><strong>Name</strong></th>
              <th><strong>Phone Number</strong></th>
              <th><strong>App Installed</strong></th>
              <th><strong>No. Of Events Invited</strong></th>
              <th><strong>RSVP Status</strong></th>
           </tr>
          </thead>
       <tbody>
  {loading ? (
    <TableLoaderRow colSpan={6} />
  ) : !guests?.length ? (
    <TableEmptyRow colSpan={6} message="No guests found" />
  ) : (
    guests.map((user, index) => (
      <tr key={user._id}>
        <td>{index + 1 + currentPage * itemsPerPage}</td>
        <td>{user.name}</td>
        <td>{`${user.countryCode} ${user.phoneNumber}`}</td>
        <td>{user?.isLogin ? "Yes":'No'} </td>
         <td>{`${user.invites.length}`}</td>
        <td>
          <button
            type="button"
            className="qx-action-view"
            title="View RSVP status"
            onClick={() => handleOpenModal(user)}
          >
            <Eye size={16} />
          </button>
        </td>
      </tr>
    ))
  )}
</tbody>
   </Table>

   {!loading && guests?.length > 0 && (
     <Pagination
       pageCount={totalPages}
       pageValue={currentPage}
       setPage={setCurrentPage}
       total={totalItems}
       pageSize={itemsPerPage}
     />
   )}
      </Card.Body>
    </Card>
<Modal
  show={showModal}
  onHide={handleCloseModal}
  centered
  className="qx-rsvp-modal"
  dialogClassName="qx-modal-dialog"
>
  <Modal.Header closeButton>
    <Modal.Title>RSVP Status</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <div className="qx-rsvp-guest">
      Guest: <strong>{selectedGuest?.name || "—"}</strong>
    </div>

    <div className="qx-rsvp-table-wrap table-responsive">
      <Table className="qx-rsvp-table mb-0">
        <thead>
          <tr>
            <th>Event</th>
            <th>Status</th>
            <th>No. of Guests</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {selectedGuest?.invites?.length ? (
            selectedGuest.invites.map((item, index) => {
              const status = (item?.status || "").toLowerCase();
              return (
                <tr key={item?._id || index}>
                  <td>{item?.event?.name?.name || "—"}</td>
                  <td>
                    <Badge
                      bg={
                        status === "accepted"
                          ? "success"
                          : status === "rejected"
                            ? "danger"
                            : status === "pending"
                              ? "warning"
                              : "secondary"
                      }
                      text={status === "pending" ? "dark" : undefined}
                    >
                      {status
                        ? status.charAt(0).toUpperCase() + status.slice(1)
                        : "—"}
                    </Badge>
                  </td>
                  <td>{item?.numberOfGuest ?? 0}</td>
                  <td>
                    <div className="qx-rsvp-action">
                      {status === "pending" ? (
                        <>
                          <button
                            type="button"
                            className="qx-rsvp-action-btn"
                            onClick={() =>
                              updateStatus(selectedGuest?._id, item?._id, "accepted")
                            }
                          >
                            Accept
                          </button>
                          <button
                            type="button"
                            className="qx-rsvp-action-btn qx-rsvp-action-btn--danger"
                            onClick={() =>
                              updateStatus(selectedGuest?._id, item?._id, "rejected")
                            }
                          >
                            Reject
                          </button>
                        </>
                      ) : status === "accepted" ? (
                        <button
                          type="button"
                          className="qx-rsvp-action-btn qx-rsvp-action-btn--danger"
                          onClick={() =>
                            updateStatus(selectedGuest?._id, item?._id, "rejected")
                          }
                        >
                          Reject
                        </button>
                      ) : (
                        <button
                          type="button"
                          className="qx-rsvp-action-btn"
                          onClick={() =>
                            updateStatus(selectedGuest?._id, item?._id, "accepted")
                          }
                        >
                          Accept
                        </button>
                      )}
                    </div>
                  </td>
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan={4} className="text-center text-muted py-4">
                No invite records found
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    </div>
  </Modal.Body>
</Modal>







    </div>
  )
}

export default USER_GUESTS
